import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import { Column } from "@faire/web/slate/Layout";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";

import { BottomSignUpBannerContent } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/BottomSignUpBannerContent";
import { BottomSignUpBannerImages } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerImages";
import { MoreToExplorePills } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/MoreToExplorePills/MoreToExplorePills";

import * as componentStyles from "./styles.css";

export const BottomSignUpBanner: React.FC = () => {
  const ref = useDoActionWhenVisible(() =>
    trackLoggedOutRetailersLoggedOutHomeRedesignView("perfect_product_banner")
  );
  return (
    <Column
      className={componentStyles.wrapper}
      align="center"
      justify={{ mobileAndAbove: "end", tabletAndAbove: "center" }}
      data-test-id="bottom-sign-up-banner"
      gap="4x"
      ref={ref}
    >
      <BottomSignUpBannerImages />
      <BottomSignUpBannerContent />
      <WhenVisibilityIsImminent>
        <MoreToExplorePills />
      </WhenVisibilityIsImminent>
    </Column>
  );
};
